module.exports = __webpack_public_path__ + "static/hro-01c1886512f8905ddb516c51a64313b0.png";